module.exports = __webpack_public_path__ + "img/OFICIOS.bd890edf.jpg";